import RemoteAutocomplete from './RemoteAutocomplete';

export const AccessTagsDropdown = (props) => {
    return <RemoteAutocomplete disabled={props.disabled} multiple resource="access_tag" urlSuffix={null} label={props.label || 'Access tags'} variant={props.variant || 'filled'} size={props.size || 'small'} fullWidth onChange={props.onChange} filterSelected value={props.value || []} helperText={props.helperText} />;
};

export default AccessTagsDropdown;
